<template>
  <div class="card-multiple-collaborators__list-wrapper">
    <div class="card-multiple-collaborators__list">
      <!-- Origem Flow: só o avatar, nome no tooltip (estilo ClickUp). -->
      <div
        v-for="item in value"
        :key="item.id"
        v-tooltip="getCollaboratorName(item, $store)"
        class="card-multiple-collaborators__item"
      >
        <template v-if="item.id && item.name">
          <img
            v-if="item.avatar_url"
            class="field-multiple-collaborators__photo field-multiple-collaborators__photo--solo"
            :src="item.avatar_url"
            :alt="getCollaboratorName(item, $store)"
          />
          <div
            v-else
            class="field-multiple-collaborators__initials field-multiple-collaborators__initials--solo"
          >
            {{ getCollaboratorNameInitials(item, $store) }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import collaboratorName from '@baserow/modules/database/mixins/collaboratorName'

export default {
  name: 'RowCardFieldMultipleCollaborators',
  height: 30,
  mixins: [collaboratorName],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
